import { NavigationConfig } from "../NavMenu";
import { Box, Button, Drawer, Grid } from "@mui/material";
import NavHeading from "../NavHeading";
import NavMenus from "../NavMenus";
import React, { useContext } from "react";
import NavFooter from "../NavFooter";
import useMobile from "../../hooks/useMobile";
import { NavbarDrawerContext } from "../../root.component";

type NavigationBarProps = {
  navigations: NavigationConfig[];
};

const CloseIcon = ({ onClose }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Button
        onClick={onClose}
        sx={{
          "&:focus": {
            outlineWidth: 0,
          },
        }}
      >
        <i className="ri-close-line" style={{ fontSize: "32px" }} />
      </Button>
    </Box>
  );
};

export default function NavigationBar(navigationBarProps: NavigationBarProps) {
  const navigations = navigationBarProps.navigations;
  const { isMobile } = useMobile();
  const { drawerState, setDrawerState } = useContext(NavbarDrawerContext);

  if (isMobile) {
    return (
      <Grid container sx={{ background: "white", marginBottom: "16px" }}>
        <Button
          aria-label="menu-icon"
          onClick={() => setDrawerState(true)}
          sx={{
            "&:focus": {
              outlineWidth: 0,
            },
          }}
        >
          <i className="ri-menu-line" style={{ fontSize: "32px" }} />
        </Button>
        <NavHeading />
        <Drawer
          open={drawerState}
          anchor={"left"}
          onClose={() => setDrawerState(false)}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <CloseIcon onClose={() => setDrawerState(false)} />
            <NavMenus navigations={navigations} />
            <NavFooter />
          </Box>
        </Drawer>
      </Grid>
    );
  }

  return (
    <Drawer
      anchor={"left"}
      color={"inherit"}
      variant={"permanent"}
      sx={navigationDrawerSx}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <NavHeading />
        <NavMenus navigations={navigations} />
        <NavFooter />
      </Box>
    </Drawer>
  );
}

const navigationDrawerSx = {
  width: "273px",
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: "273px",
    boxSizing: "border-box",
    overflowY: "hidden",
    borderRight: "0px",
  },
};
